(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-ingredients"] && !Shopify.designMode) return;
  try {
    
function initializeIngredientHubs(root=document){
 root.querySelectorAll('[data-ingredient-hub]').forEach(hub=>{
 if(hub.dataset.ready)return;hub.dataset.ready='true';
 const controls=hub.querySelector('[data-search-controls]'),input=hub.querySelector('input'),cards=[...hub.querySelectorAll('[data-ingredient]')],count=hub.querySelector('[data-count]');
 const filter=()=>{const q=input.value.trim().normalize('NFKC').toLocaleLowerCase();let n=0;cards.forEach(card=>{const matches=card.dataset.search.normalize('NFKC').toLocaleLowerCase().includes(q);card.hidden=!matches;if(matches)n++});count.textContent=count.dataset.template.replace('[count]',String(n));hub.querySelector('[data-empty]').hidden=n>0};
 controls.hidden=false;input.addEventListener('input',filter);hub.querySelector('[data-clear]').addEventListener('click',()=>{input.value='';filter();input.focus()});filter();
 });
}
initializeIngredientHubs();document.addEventListener('shopify:section:load',event=>initializeIngredientHubs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-home-2026"] && !Shopify.designMode) return;
  try {
    
function initializeNutricareHomepage(root) {
  if (!root || root.hasAttribute('data-filters-ready')) return;
  const refreshOffer = () => root.querySelectorAll('[data-home-offer-until]').forEach(offer => {
    offer.hidden = Date.now() >= Date.parse(offer.dataset.homeOfferUntil);
  });
  refreshOffer();
  document.addEventListener('visibilitychange', refreshOffer);
  const expiry = root.querySelector('[data-home-offer-until]');
  if (expiry) {
    const remaining = Date.parse(expiry.dataset.homeOfferUntil) - Date.now();
    if (remaining > 0 && remaining < 2147483647) setTimeout(refreshOffer, remaining);
  }
  const buttons = root.querySelectorAll('[data-filter]');
  const cards = root.querySelectorAll('[data-category]');
  if (!buttons.length || !cards.length) return;
  buttons.forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.filter;
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
  }));
  root.setAttribute('data-filters-ready', '');
}
document.querySelectorAll('.nc-homepage').forEach(initializeNutricareHomepage);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.nc-homepage').forEach(initializeNutricareHomepage);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-verification"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('nc-verification-results')) {
  customElements.define('nc-verification-results', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const list = this.querySelector('.nv-result-tabs');
      const tabs = Array.from(list.querySelectorAll('button'));
      const panels = Array.from(this.querySelectorAll('.nv-result'));
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      list.setAttribute('role', 'tablist');
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          let index;
          if (event.key === 'ArrowRight') index = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') index = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = tabs.length - 1;
          if (index !== undefined) { event.preventDefault(); select(index, true); }
        });
      });
      select(0);
      list.hidden = false;
      this.dataset.ready = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutricare-glpro-brochure"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glpro-brochure')) {
  customElements.define('glpro-brochure', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog'), launch = this.querySelector('[data-open]'), zoom = this.querySelector('[data-zoom]');
      this.restore = () => { document.body.style.overflow = this.previousOverflow; launch.focus(); };
      launch.addEventListener('click', () => {
        dialog.querySelectorAll('[data-src]').forEach(img => {img.src = img.dataset.src; delete img.dataset.src;});
        this.previousOverflow = document.body.style.overflow;
        dialog.showModal(); document.body.style.overflow = 'hidden';
      });
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', this.restore);
      zoom.addEventListener('click', () => { const on = dialog.classList.toggle('ngb-zoomed'); zoom.setAttribute('aria-pressed', String(on)); zoom.textContent = on ? zoom.dataset.fit : zoom.dataset.label; });
    }
    disconnectedCallback() { if (this.querySelector('dialog')?.open) this.restore(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutricare-glpro-v2"]) return;
  try {
    
if (!customElements.get('glpro-page')) {
  customElements.define('glpro-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.dialog = this.querySelector('dialog');
      this.pages = [...this.querySelectorAll('[data-book-page]')];
      this.viewport = this.querySelector('.gv-viewport');
      this.sheetWrap = this.querySelector('.gv-sheet-wrap');
      this.page = 0; this.zoom = 1;
      this.sticky = this.querySelector('.gv-sticky-buy');
      this.mobileQuery = window.matchMedia('(max-width:749px)');
      this.originalAdd = this.querySelector('.gv-add');
      this.updateSticky = () => {
        this.sticky.hidden = !this.mobileQuery.matches || this.dialog.open || this.originalAdd.getBoundingClientRect().bottom > 0;
      };
      this.buyObserver = new IntersectionObserver(this.updateSticky, {threshold:0});
      this.buyObserver.observe(this.originalAdd);
      window.addEventListener('scroll', this.updateSticky, {passive:true});
      this.mobileQuery.addEventListener('change', this.updateSticky);
      this.selectVariant(this.querySelector('input[name=id]:checked').value, false);
      this.updateSticky();
      this.addEventListener('change', event => {
        if (event.target.name !== 'id') return;
        this.selectVariant(event.target.value, true);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-photo')) {
          const photo = this.querySelector('.gv-photo');
          photo.srcset = ''; photo.src = button.dataset.photo; photo.alt = button.dataset.alt;
          this.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        }
        if (button.hasAttribute('data-open-book')) {
          this.opener = button;
          this.oldOverflow = document.body.style.overflow;
          this.page = Math.max(0, Math.min(this.pages.length - 1, Number(button.dataset.openBook) || 0)); this.zoom = 1;
          this.dialog.showModal(); document.body.style.overflow = 'hidden'; this.updateSticky();
          this.updateZoom();
          this.dialog.querySelector('[data-close-book]').focus({preventScroll:true});
          requestAnimationFrame(() => {
            this.viewport.scrollTop = 0; this.viewport.scrollLeft = 0;
            const target = this.pages[this.page];
            this.viewport.scrollTop = target.getBoundingClientRect().top - this.viewport.getBoundingClientRect().top - parseFloat(getComputedStyle(this.viewport).paddingTop);
          });
        }
        if (button.hasAttribute('data-close-book')) this.dialog.close();
        if (button.hasAttribute('data-zoom-in')) { this.zoom = Math.min(4, this.zoom + .25); this.updateZoom(); }
        if (button.hasAttribute('data-zoom-out')) { this.zoom = Math.max(1, this.zoom - .25); this.updateZoom(); }
        if (button.hasAttribute('data-reset')) { this.zoom = 1; this.updateZoom(); }
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.oldOverflow || '';
        this.opener?.focus({preventScroll:true});
        this.updateSticky();
      });

      this.viewport.addEventListener('pointerdown', event => {
        if (this.zoom <= 1 || event.pointerType !== 'mouse' || event.target.closest('a,button')) return;
        this.drag = {x:event.clientX,y:event.clientY,left:this.viewport.scrollLeft,top:this.viewport.scrollTop};
        this.viewport.setPointerCapture(event.pointerId); this.viewport.classList.add('gv-dragging');
      });
      this.viewport.addEventListener('pointermove', event => {
        if (!this.drag) return;
        this.viewport.scrollLeft = this.drag.left - event.clientX + this.drag.x;
        this.viewport.scrollTop = this.drag.top - event.clientY + this.drag.y;
      });
      const endDrag = () => { this.drag = null; this.viewport.classList.remove('gv-dragging'); };
      this.viewport.addEventListener('pointerup', endDrag);
      this.viewport.addEventListener('pointercancel', endDrag);
      this.onPopstate = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const radio = [...this.querySelectorAll('input[name=id]')].find(input => input.value === id);
        if (radio) { radio.checked = true; this.selectVariant(id, false); }
      };
      window.addEventListener('popstate', this.onPopstate);
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.updateSticky); this.buyObserver?.disconnect(); this.mobileQuery?.removeEventListener('change', this.updateSticky); window.removeEventListener('popstate', this.onPopstate); if(this.dialog?.open) document.body.style.overflow = this.oldOverflow || ''; }
    selectVariant(id, updateUrl) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelector('[data-price]').textContent = variant.price;
      const submit = this.querySelector('.gv-add'); submit.disabled = !variant.available;
      submit.textContent = variant.available ? this.dataset.add : this.dataset.sold;
      const selected = [...this.querySelectorAll('input[name=id]')].find(input => input.value === String(id));
      this.querySelector('.gv-sticky-label').textContent = selected?.dataset.packageLabel || '';
      this.querySelector('[data-selection-label]').textContent = selected?.dataset.packageLabel || '';
      this.querySelector('.gv-sticky-price').textContent = variant.price;
      const stickyAdd = this.querySelector('.gv-sticky-add');
      stickyAdd.disabled = !variant.available;
      stickyAdd.textContent = submit.textContent;
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', id); history.replaceState({}, '', url); }
    }
    updateZoom() {
      const ratio = this.zoom / (this.appliedZoom || 1);
      const viewTop = this.viewport.getBoundingClientRect().top;
      const anchor = this.pages.find(page => page.getBoundingClientRect().bottom > viewTop) || this.pages[0];
      const before = anchor.getBoundingClientRect();
      const fraction = (viewTop - before.top) / before.height;
      const left = this.viewport.scrollLeft * ratio;
      this.sheetWrap.style.zoom = this.zoom;
      this.appliedZoom = this.zoom;
      this.querySelector('[data-zoom]').textContent = `${Math.round(this.zoom * 100)}%`;
      this.querySelector('[data-zoom-out]').disabled = this.zoom <= 1;
      this.querySelector('[data-zoom-in]').disabled = this.zoom >= 4;
      const after = anchor.getBoundingClientRect();
      this.viewport.scrollTo(left, this.viewport.scrollTop + after.top - viewTop + fraction * after.height);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutricare-product-v2"]) return;
  try {
    
if(!customElements.get('nutricare-product-page'))customElements.define('nutricare-product-page',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.dialog=this.querySelector('.pv-dialog');this.imageDialog=this.querySelector('.pv-image-dialog');this.viewport=this.querySelector('.pv-viewport');this.sheetWrap=this.querySelector('.pv-sheet-wrap');this.pages=[...this.querySelectorAll('[data-book-page]')];this.zoom=1;
  this.picks=[...this.querySelectorAll('[data-pick]')];this.originalAdd=this.querySelector('.pv-add');this.sticky=this.querySelector('.pv-sticky-buy');this.media=matchMedia('(max-width:749px)');
  this.updateSticky=()=>{this.sticky.hidden=!this.media.matches||this.dialog.open||this.imageDialog.open||this.originalAdd.getBoundingClientRect().bottom>0};
  this.observer=new IntersectionObserver(this.updateSticky);this.observer.observe(this.originalAdd);window.addEventListener('scroll',this.updateSticky,{passive:true});this.media.addEventListener('change',this.updateSticky);
  const pairbox=this.querySelector('.pv-pairs');this.pairSelects=[...this.querySelectorAll('[data-pair]')];
  if(pairbox){pairbox.hidden=false;this.querySelector('.pv-pair-options').hidden=true;if(this.dataset.handle==='tmk-imuglo-bundle'){const o=document.createElement('option');o.value='8';o.textContent='8 盒（特別組合）';this.pairSelects[0].append(o)}}
  let first=this.picks.find(p=>p.checked)||this.picks[0];const qty=new URL(location.href).searchParams.get('quantity');if(this.dataset.handle==='moveon'&&qty)first=this.picks.find(p=>p.value===qty)||first;this.selectChoice(first,false);this.updateSticky();
  if(this.dataset.handle==='moveon'){this.addEventListener('click',e=>{if(e.target.closest('.pv-add,.pv-sticky-add'))this.syncMoveonQuantity()},true);this.addEventListener('submit',()=>this.syncMoveonQuantity(),true)}
  this.addEventListener('change',e=>{if(e.target.matches('[data-pick]'))this.selectChoice(e.target,true);if(e.target.matches('[data-pair]'))this.choosePair()});
  this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;
   if(b.hasAttribute('data-photo')){const im=this.querySelector('.pv-photo');im.srcset='';im.src=b.dataset.photo;im.alt=b.dataset.alt;this.querySelectorAll('[data-photo]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)))}
   if(b.hasAttribute('data-special')){this.selectChoice(this.picks.find(p=>p.dataset.a==='8'&&p.dataset.b==='4'),true)}
   if(b.hasAttribute('data-open-book')){this.opener=b;this.oldOverflow=document.body.style.overflow;this.page=Math.max(0,Math.min(this.pages.length-1,Number(b.dataset.openBook)||0));this.zoom=1;this.appliedZoom=1;this.sheetWrap.style.zoom=1;this.dialog.showModal();document.body.style.overflow='hidden';this.updateZoom();this.updateSticky();this.dialog.querySelector('[data-close-book]').focus({preventScroll:true});requestAnimationFrame(()=>{this.viewport.scrollTop=0;this.viewport.scrollLeft=0;this.viewport.scrollTop=this.pages[this.page].getBoundingClientRect().top-this.viewport.getBoundingClientRect().top-parseFloat(getComputedStyle(this.viewport).paddingTop)})}
   if(b.hasAttribute('data-close-book'))this.dialog.close();
   if(b.hasAttribute('data-zoom-in')){this.zoom=Math.min(4,this.zoom+.25);this.updateZoom()}
   if(b.hasAttribute('data-zoom-out')){this.zoom=Math.max(1,this.zoom-.25);this.updateZoom()}
   if(b.hasAttribute('data-reset')){this.zoom=1;this.updateZoom()}
   if(b.hasAttribute('data-open-image')){this.imageOpener=b;this.oldOverflow=document.body.style.overflow;const im=this.querySelector('[data-label-photo]');im.src=b.dataset.openImage;im.alt=b.dataset.imageAlt;im.style.width='100%';this.imageDialog.showModal();document.body.style.overflow='hidden';this.updateSticky()}
   if(b.hasAttribute('data-toggle-image')){const im=this.querySelector('[data-label-photo]');im.style.width=im.style.width==='200%'?'100%':'200%';b.setAttribute('aria-pressed',String(im.style.width==='200%'))}
   if(b.hasAttribute('data-close-image'))this.imageDialog.close();
  });
  this.querySelector('[data-label-photo]').addEventListener('click',e=>{e.target.style.width=e.target.style.width==='200%'?'100%':'200%'});
  this.dialog.addEventListener('close',()=>{document.body.style.overflow=this.oldOverflow||'';this.opener?.focus({preventScroll:true});this.updateSticky()});this.imageDialog.addEventListener('close',()=>{document.body.style.overflow=this.oldOverflow||'';this.imageOpener?.focus({preventScroll:true});this.updateSticky()});
  this.viewport.addEventListener('pointerdown',e=>{if(this.zoom<=1||e.pointerType!=='mouse'||e.target.closest('button,a'))return;this.drag={x:e.clientX,y:e.clientY,left:this.viewport.scrollLeft,top:this.viewport.scrollTop};this.viewport.setPointerCapture(e.pointerId);this.viewport.classList.add('pv-dragging')});
  this.viewport.addEventListener('pointermove',e=>{if(!this.drag)return;this.viewport.scrollLeft=this.drag.left-e.clientX+this.drag.x;this.viewport.scrollTop=this.drag.top-e.clientY+this.drag.y});
  const end=()=>{this.drag=null;this.viewport.classList.remove('pv-dragging')};this.viewport.addEventListener('pointerup',end);this.viewport.addEventListener('pointercancel',end);
  this.onPop=()=>{const u=new URL(location.href);const key=this.dataset.handle==='moveon'?u.searchParams.get('quantity'):u.searchParams.get('variant');const p=this.picks.find(x=>x.value===key)||this.picks[0];this.selectChoice(p,false)};window.addEventListener('popstate',this.onPop);
 }
 syncMoveonQuantity(){
  if(this.dataset.handle!=='moveon'||this.syncingMoveon)return;
  const selected=this.picks.find(p=>p.checked),quantity=this.querySelector('[data-moveon-quantity]');
  if(!selected||!quantity)return;
  this.syncingMoveon=true;
  try{
   const radio=this.querySelector(`.bundler-volume-target-element[data-bundle="865741"] input[name="bundle_quantity"][value="${selected.value}"]`);
   if(radio&&!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}))}
   quantity.value=selected.value;
  }finally{this.syncingMoveon=false}
 }
 choosePair(){const a=this.pairSelects[0].value,b=this.pairSelects[1].value;const p=this.picks.find(x=>x.dataset.a===a&&x.dataset.b===b)||this.picks.find(x=>x.dataset.a===a&&!x.disabled)||this.picks.find(x=>x.dataset.a===a);this.selectChoice(p,true)}
 selectChoice(p,update){if(!p)return;p.checked=true;this.syncMoveonQuantity();const available=p.dataset.available==='true';const price=p.dataset.price;this.querySelector('.pv-total [data-price]').textContent=price;this.originalAdd.disabled=!available;this.originalAdd.textContent=available?this.dataset.add:this.dataset.sold;this.querySelector('.pv-sticky-price').textContent=price;this.querySelector('.pv-sticky-label').textContent=p.dataset.packageLabel;this.querySelector('.pv-sticky-add').disabled=!available;this.querySelector('.pv-sticky-add').textContent=this.originalAdd.textContent;const detail=this.querySelector('[data-selected-detail]');detail.textContent=p.dataset.detail||'';detail.hidden=!detail.textContent;const choice=this.querySelector('[data-selection-label]');if(choice)choice.textContent=choice.hasAttribute('data-short-label')?(p.dataset.packageLabel||'').split('｜')[0].trim():(p.dataset.packageLabel||'');
  if(this.pairSelects.length){this.pairSelects[0].value=p.dataset.a;this.pairSelects[1].value=p.dataset.b;[...this.pairSelects[1].options].forEach(o=>o.disabled=!this.picks.some(x=>x.dataset.a===p.dataset.a&&x.dataset.b===o.value));this.querySelector('[data-special]')?.setAttribute('aria-pressed',String(p.dataset.a==='8'))}
  if(update){const u=new URL(location.href);if(this.dataset.handle==='moveon'){u.searchParams.set('quantity',p.value);u.searchParams.set('variant',this.querySelector('input[name=id]').value)}else u.searchParams.set('variant',p.value);history.replaceState({},'',u)}
  p.dispatchEvent(new Event('input',{bubbles:true}));
 }
 updateZoom(){const top=this.viewport.getBoundingClientRect().top,anchor=this.pages.find(p=>p.getBoundingClientRect().bottom>top)||this.pages[0],before=anchor.getBoundingClientRect(),fraction=(top-before.top)/before.height,left=this.viewport.scrollLeft*this.zoom/(this.appliedZoom||1);this.sheetWrap.style.zoom=this.zoom;this.appliedZoom=this.zoom;this.querySelector('[data-zoom]').textContent=Math.round(this.zoom*100)+'%';this.querySelector('[data-zoom-out]').disabled=this.zoom<=1;this.querySelector('[data-zoom-in]').disabled=this.zoom>=4;const after=anchor.getBoundingClientRect();this.viewport.scrollTo(left,this.viewport.scrollTop+after.top-top+fraction*after.height)}
 disconnectedCallback(){window.removeEventListener('scroll',this.updateSticky);window.removeEventListener('popstate',this.onPop);this.media?.removeEventListener('change',this.updateSticky);this.observer?.disconnect();if(this.dialog?.open||this.imageDialog?.open)document.body.style.overflow=this.oldOverflow||''}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutricare-tmk-brochure"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tmk-brochure')) {
  customElements.define('tmk-brochure', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog'), launch = this.querySelector('[data-open]'), zoom = this.querySelector('[data-zoom]');
      this.restore = () => { document.body.style.overflow = this.previousOverflow; launch.focus(); };
      launch.addEventListener('click', () => {
        dialog.querySelectorAll('[data-src]').forEach(img => {img.src = img.dataset.src; delete img.dataset.src;});
        this.previousOverflow = document.body.style.overflow;
        dialog.showModal(); document.body.style.overflow = 'hidden';
      });
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', this.restore);
      zoom.addEventListener('click', () => { const on = dialog.classList.toggle('ntb-zoomed'); zoom.setAttribute('aria-pressed', String(on)); zoom.textContent = on ? zoom.dataset.fit : zoom.dataset.label; });
    }
    disconnectedCallback() { if (this.querySelector('dialog')?.open) this.restore(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutricare-tmk-v2"]) return;
  try {
    
if (!customElements.get('tmk-page')) {
  customElements.define('tmk-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.dialog = this.querySelector('dialog');
      this.pages = [...this.querySelectorAll('[data-book-page]')];
      this.viewport = this.querySelector('.tv-viewport');
      this.sheetWrap = this.querySelector('.tv-sheet-wrap');
      this.page = 0; this.zoom = 1;
      this.sticky = this.querySelector('.tv-sticky-buy');
      this.mobileQuery = window.matchMedia('(max-width:749px)');
      this.originalAdd = this.querySelector('.tv-add');
      this.updateSticky = () => {
        this.sticky.hidden = !this.mobileQuery.matches || this.dialog.open || this.originalAdd.getBoundingClientRect().bottom > 0;
      };
      this.buyObserver = new IntersectionObserver(this.updateSticky, {threshold:0});
      this.buyObserver.observe(this.originalAdd);
      window.addEventListener('scroll', this.updateSticky, {passive:true});
      this.mobileQuery.addEventListener('change', this.updateSticky);
      this.selectVariant(this.querySelector('input[name=id]:checked').value, false);
      this.updateSticky();
      this.addEventListener('change', event => {
        if (event.target.name !== 'id') return;
        this.selectVariant(event.target.value, true);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-photo')) {
          const photo = this.querySelector('.tv-photo');
          photo.srcset = ''; photo.src = button.dataset.photo; photo.alt = button.dataset.alt;
          this.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        }
        if (button.hasAttribute('data-open-book')) {
          this.opener = button;
          this.oldOverflow = document.body.style.overflow;
          this.page = Math.max(0, Math.min(this.pages.length - 1, Number(button.dataset.openBook) || 0)); this.zoom = 1;
          this.dialog.showModal(); document.body.style.overflow = 'hidden'; this.updateSticky();
          this.updateZoom();
          this.dialog.querySelector('[data-close-book]').focus({preventScroll:true});
          requestAnimationFrame(() => {
            this.viewport.scrollTop = 0; this.viewport.scrollLeft = 0;
            const target = this.pages[this.page];
            this.viewport.scrollTop = target.getBoundingClientRect().top - this.viewport.getBoundingClientRect().top - parseFloat(getComputedStyle(this.viewport).paddingTop);
          });
        }
        if (button.hasAttribute('data-close-book')) this.dialog.close();
        if (button.hasAttribute('data-zoom-in')) { this.zoom = Math.min(4, this.zoom + .25); this.updateZoom(); }
        if (button.hasAttribute('data-zoom-out')) { this.zoom = Math.max(1, this.zoom - .25); this.updateZoom(); }
        if (button.hasAttribute('data-reset')) { this.zoom = 1; this.updateZoom(); }
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.oldOverflow || '';
        this.opener?.focus({preventScroll:true});
        this.updateSticky();
      });

      this.viewport.addEventListener('pointerdown', event => {
        if (this.zoom <= 1 || event.pointerType !== 'mouse' || event.target.closest('a,button')) return;
        this.drag = {x:event.clientX,y:event.clientY,left:this.viewport.scrollLeft,top:this.viewport.scrollTop};
        this.viewport.setPointerCapture(event.pointerId); this.viewport.classList.add('tv-dragging');
      });
      this.viewport.addEventListener('pointermove', event => {
        if (!this.drag) return;
        this.viewport.scrollLeft = this.drag.left - event.clientX + this.drag.x;
        this.viewport.scrollTop = this.drag.top - event.clientY + this.drag.y;
      });
      const endDrag = () => { this.drag = null; this.viewport.classList.remove('tv-dragging'); };
      this.viewport.addEventListener('pointerup', endDrag);
      this.viewport.addEventListener('pointercancel', endDrag);
      this.onPopstate = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const radio = [...this.querySelectorAll('input[name=id]')].find(input => input.value === id);
        if (radio) { radio.checked = true; this.selectVariant(id, false); }
      };
      window.addEventListener('popstate', this.onPopstate);
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.updateSticky); this.buyObserver?.disconnect(); this.mobileQuery?.removeEventListener('change', this.updateSticky); window.removeEventListener('popstate', this.onPopstate); if(this.dialog?.open) document.body.style.overflow = this.oldOverflow || ''; }
    selectVariant(id, updateUrl) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.querySelector('[data-price]').textContent = variant.price;
      const summary = this.querySelector('.tv-compact-summary');
      const boxes = variant.boxes;
      const unit = this.querySelector('[data-compact-unit]');
      unit.textContent = boxes > 1 ? summary.dataset.unit.replace('[price]', variant.unitPrice) : '';
      unit.hidden = boxes <= 1;
      const giftAverage = this.querySelector('[data-compact-average]');
      if (giftAverage) giftAverage.textContent = summary.dataset.average.replace('[boxes]', boxes + Math.floor(boxes / 6)).replace('[price]', variant.giftAverage);
      if (giftAverage) giftAverage.hidden = boxes < 6;
      const submit = this.querySelector('.tv-add'); submit.disabled = !variant.available;
      submit.textContent = variant.available ? this.dataset.add : this.dataset.sold;
      const selected = [...this.querySelectorAll('input[name=id]')].find(input => input.value === String(id));
      this.querySelector('.tv-sticky-label').textContent = selected?.dataset.packageLabel || '';
      this.querySelector('[data-selection-label]').textContent = selected?.dataset.packageLabel || '';
      this.querySelector('.tv-sticky-price').textContent = variant.price;
      const stickyAdd = this.querySelector('.tv-sticky-add');
      stickyAdd.disabled = !variant.available;
      stickyAdd.textContent = submit.textContent;
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', id); history.replaceState({}, '', url); }
    }
    updateZoom() {
      const ratio = this.zoom / (this.appliedZoom || 1);
      const viewTop = this.viewport.getBoundingClientRect().top;
      const anchor = this.pages.find(page => page.getBoundingClientRect().bottom > viewTop) || this.pages[0];
      const before = anchor.getBoundingClientRect();
      const fraction = (viewTop - before.top) / before.height;
      const left = this.viewport.scrollLeft * ratio;
      this.sheetWrap.style.zoom = this.zoom;
      this.appliedZoom = this.zoom;
      this.querySelector('[data-zoom]').textContent = `${Math.round(this.zoom * 100)}%`;
      this.querySelector('[data-zoom-out]').disabled = this.zoom <= 1;
      this.querySelector('[data-zoom-in]').disabled = this.zoom >= 4;
      const after = anchor.getBoundingClientRect();
      this.viewport.scrollTo(left, this.viewport.scrollTop + after.top - viewTop + fraction * after.height);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutricare-wellous-gifts"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wellous-gifts')){
  customElements.define('wellous-gifts',class extends HTMLElement{
    connectedCallback(){
      this.weights=JSON.parse(this.querySelector('[data-weights]').textContent);
      this.strings=JSON.parse(this.querySelector('[data-strings]').textContent);
      this.cards=[...this.querySelectorAll('[data-gift]')];this.selected={};this.chain=Promise.resolve();this.busy=false;this.revision=0;
      this.keys={selection:'Wellous 贈品選擇',summary:'Wellous 9月贈品',units:'Wellous 活動單位',review:'Wellous 出貨核對'};
      this.cart=JSON.parse(this.querySelector('[data-initial]').textContent);this.giftIds=new Set(this.cards.map(c=>String(c.dataset.variant)));
      try{const restored=JSON.parse(this.cart.attributes?.[this.keys.selection]||'{}');for(const card of this.cards){const n=restored[card.dataset.gift];if(Number.isSafeInteger(n)&&n>0&&card.dataset.available==='true')this.selected[card.dataset.gift]=n;}}catch{}
      if(this.cart.items.some(i=>this.giftIds.has(String(i.variant_id))))this.restoreGifts(this.cart);
      this.abort=new AbortController();const signal=this.abort.signal;
      this.addEventListener('click',e=>{const b=e.target.closest('[data-delta]');if(b){if(this.busy||this.checkingOut)return;const key=b.closest('[data-gift]').dataset.gift;this.selected[key]=Math.max(0,(this.selected[key]||0)+Number(b.dataset.delta));this.revision++;this.render();this.save().catch(()=>{});}if(e.target.closest('[data-save]'))this.save().catch(()=>{});if(e.target.closest('[data-toggle]')){this.expanded=!this.expanded;this.render();}if(e.target.closest('[data-continue]')){this.expanded=true;this.render();}},{signal});
      this.submitHandler=e=>{if(e.target.id!=='cart'||e.submitter?.name!=='checkout'||this.passThrough)return;e.preventDefault();e.stopImmediatePropagation();this.checkout(e.target,e.submitter);};
      document.addEventListener('submit',this.submitHandler,{capture:true,signal});
      window.addEventListener('click',e=>{const button=e.target.closest?.('button[name="checkout"]');const form=button?.form;if(form?.id!=='cart'||this.passThrough)return;e.preventDefault();e.stopImmediatePropagation();this.checkout(form,button);},{capture:true,signal});
      document.addEventListener('change',e=>{if(e.target.matches('[name="updates[]"]')){this.cartBusy=true;clearTimeout(this.refreshTimer);this.refreshTimer=setTimeout(()=>{this.cartBusy=false;this.refresh(true).catch(()=>{});},1100);}},{capture:true,signal});
      if(typeof subscribe==='function')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{this.cartBusy=false;clearTimeout(this.refreshTimer);this.refresh(true).catch(()=>{});});
      document.addEventListener('shopify:cart:lines-update',()=>this.refresh(true).catch(()=>{}),{signal});
      window.addEventListener('pageshow',()=>this.refresh(true).catch(()=>{}),{signal});
      document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.refresh(true).catch(()=>{});},{signal});
      this.render();this.refresh(true).catch(()=>{});
      this.expiryTimer=setInterval(()=>{if(this.active()!==this.wasActive)this.refresh(true).catch(()=>{});},30000);
    }
    disconnectedCallback(){this.abort?.abort();this.unsubscribe?.();clearTimeout(this.refreshTimer);clearInterval(this.expiryTimer);}
    text(key,values={}){let t=this.strings[key];for(const [k,v]of Object.entries(values))t=t.replaceAll('['+k+']',v);return t;}
    active(){const now=Date.now()/1000;return this.dataset.enabled==='true'&&now>=Number(this.dataset.start)&&now<Number(this.dataset.end);}
    calculate(){let units=0;this.unknown=false;this.lines=[];for(const item of this.cart.items){if(this.giftIds.has(String(item.variant_id)))continue;const w=this.weights[String(item.variant_id)];if(w===undefined){this.unknown=true;continue;}const n=w*item.quantity;units+=n;if(n)this.lines.push({name:item.product_title+' · '+item.variant_title,quantity:item.quantity,units:n});}this.units=units;this.entitlement=this.active()?Math.floor(units/6):0;this.count=Object.values(this.selected).reduce((s,n)=>s+n,0);}
    render(){
      this.calculate();this.wasActive=this.active();this.dataset.active=String(this.wasActive);const visible=this.wasActive&&this.cart.item_count>0;
      this.querySelector('[data-panel]').hidden=!visible;this.querySelector('[data-picker]').hidden=!this.entitlement&&!this.count;
      this.querySelector('[data-total]').textContent=this.text('units',{units:this.units,gifts:this.entitlement});
      this.querySelector('[data-next]').textContent=this.text('next',{units:6-this.units%6});
      this.querySelector('[data-remaining]').textContent=this.text('remaining',{selected:this.count,gifts:this.entitlement});
      const list=this.querySelector('[data-breakdown]');list.replaceChildren();for(const line of this.lines){const li=document.createElement('li');li.textContent=line.name+' × '+line.quantity+' → '+line.units;list.append(li);}
      for(const [index,card] of this.cards.entries()){const n=this.selected[card.dataset.gift]||0;card.hidden=!this.expanded&&index>=4&&!n;card.dataset.selected=String(n>0);card.querySelector('output').textContent=n;card.querySelector('[data-delta="-1"]').disabled=!n||this.checkingOut||this.busy;card.querySelector('[data-delta="1"]').disabled=card.dataset.available!=='true'||this.count>=this.entitlement||this.checkingOut||this.busy;}
      const toggle=this.querySelector('[data-toggle]');toggle.hidden=this.cards.length<=4;toggle.setAttribute('aria-expanded',String(!!this.expanded));toggle.textContent=this.text(this.expanded?'show_less':'show_all');
      this.querySelector('[data-selection]').hidden=!this.entitlement&&!this.count;
      this.querySelector('[data-summary-count]').textContent=this.text('remaining',{selected:this.count,gifts:this.entitlement});
      const summary=this.querySelector('[data-selected-list]');summary.replaceChildren();
      for(const card of this.cards){const n=this.selected[card.dataset.gift]||0;if(n){const li=document.createElement('li');li.textContent=card.dataset.name+' · '+card.dataset.pack+' × '+n;summary.append(li);}}
      if(!this.count){const li=document.createElement('li');li.textContent=this.text('empty');summary.append(li);}
      this.querySelector('[data-left]').textContent=this.count<this.entitlement?this.text('left',{count:this.entitlement-this.count}):this.count===this.entitlement?this.text('complete'):'';
      this.querySelector('[data-continue]').hidden=this.count>=this.entitlement;
      const error=this.querySelector('[data-error]');error.hidden=!this.unknown&&this.count<=this.entitlement;error.textContent=this.count>this.entitlement?this.text('excess',{count:this.count-this.entitlement}):(this.unknown?this.text('unknown'):'');
    }
    async readCart(){const response=await fetch(window.Shopify.routes.root+'cart.js',{cache:'no-store'});if(!response.ok)throw new Error('Cart read failed');return response.json();}
    giftSignature(cart){return JSON.stringify(cart.items.filter(i=>this.giftIds.has(String(i.variant_id))).map(i=>[i.key,i.quantity]));}
    restoreGifts(cart){this.selected={};for(const card of this.cards){const n=cart.items.filter(i=>String(i.variant_id)===card.dataset.variant).reduce((sum,i)=>sum+i.quantity,0);if(n)this.selected[card.dataset.gift]=n;}}
    async refresh(persist){if(this.busy)await this.chain.catch(()=>{});const cart=await this.readCart();if(this.giftSignature(cart)!==this.giftSignature(this.cart))this.restoreGifts(cart);this.cart=cart;this.render();if(persist)await this.save();}
    sectionTargets(){return [{id:'main-cart-items',selector:'.js-contents'},{id:'main-cart-footer',selector:'.js-contents'},{id:'cart-icon-bubble',selector:'.shopify-section'}].map(t=>({...t,section:document.getElementById(t.id)?.dataset.id||t.id}));}
    applySections(sections){if(!sections)return;for(const target of this.sectionTargets()){const html=sections[target.section];const root=document.getElementById(target.id);if(!html||!root)continue;const parsed=new DOMParser().parseFromString(html,'text/html');const source=parsed.querySelector(target.selector);const destination=root.querySelector(target.selector)||root;if(source)destination.innerHTML=source.innerHTML;}
      document.querySelector('cart-items')?.classList.toggle('is-empty',this.cart.item_count===0);document.getElementById('main-cart-footer')?.classList.toggle('is-empty',this.cart.item_count===0);
    }
    async postCart(endpoint,body){const response=await fetch(window.Shopify.routes.root+endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});if(!response.ok)throw new Error('Gift cart update failed');return response.json();}
    async syncGiftLines(){
      const valid=this.active()&&this.entitlement>0&&this.count<=this.entitlement;
      const updates={};const additions=[];const expected={};
      for(const card of this.cards){
        const id=card.dataset.variant;const wanted=valid&&card.dataset.available==='true'?(this.selected[card.dataset.gift]||0):0;expected[id]=wanted;
        const lines=this.cart.items.filter(i=>String(i.variant_id)===id);
        if(lines.length){for(const [index,line] of lines.entries()){const quantity=index===0?wanted:0;if(line.quantity!==quantity)updates[line.key]=quantity;}}
        else if(wanted)additions.push({id:Number(id),quantity:wanted,properties:{'活動':'Wellous 九月贈品','出貨安排':'核對資格後隨貨附送','_nc_wellous_gift':'2026-09'}});
      }
      const changed=Object.keys(updates).length>0||additions.length>0;
      if(Object.keys(updates).length)this.cart=await this.postCart('cart/update.js',{updates});
      if(additions.length){await this.postCart('cart/add.js',{items:additions});this.cart=await this.readCart();}
      if(changed){
        for(const [id,wanted] of Object.entries(expected)){if(this.cart.items.filter(i=>String(i.variant_id)===id).reduce((sum,i)=>sum+i.quantity,0)!==wanted)throw new Error('Gift quantity mismatch');}
      }
      return changed;
    }
    attributes(){
      const valid=this.active()&&this.entitlement>0&&this.count<=this.entitlement;const chosen=valid?Object.fromEntries(Object.entries(this.selected).filter(([,n])=>n>0)):{};
      const summary=this.cards.filter(c=>chosen[c.dataset.gift]).map(c=>c.dataset.name+'（'+c.dataset.pack+'）× '+chosen[c.dataset.gift]).join('；');
      return {[this.keys.selection]:Object.keys(chosen).length?JSON.stringify(chosen):'',[this.keys.summary]:summary,[this.keys.units]:this.active()&&this.entitlement>0?String(this.units):'',[this.keys.review]:this.active()&&this.entitlement>0?'2026-09 Wellous｜每滿6個付費單位送1件｜可選'+this.entitlement+'件｜已選'+(valid?this.count:0)+'件｜出貨前核對實付單位、贈品及庫存':''};
    }
    save(){
      const task=async()=>{
        this.querySelector('[data-save]').hidden=true;this.querySelector('[data-status]').textContent=this.text('saving');this.busy=true;this.render();
        try{
          let retries=0;while(this.cartBusy||document.querySelector('.cart__items--disabled')){if(++retries>50)throw new Error('Cart still updating');await new Promise(resolve=>setTimeout(resolve,200));}
          this.cart=await this.readCart();this.render();const linesChanged=await this.syncGiftLines();this.sectionsDirty=this.sectionsDirty||linesChanged;const attributes=this.attributes();
          if(this.sectionsDirty||Object.entries(attributes).some(([k,v])=>(this.cart.attributes?.[k]||'')!==v)){
            const response=await fetch(window.Shopify.routes.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes,sections:this.sectionTargets().map(t=>t.section),sections_url:window.location.pathname})});
            if(!response.ok)throw new Error('Save failed');this.cart=await response.json();if(this.sectionsDirty){this.applySections(this.cart.sections);this.sectionsDirty=false;}
            if(Object.entries(attributes).some(([k,v])=>(this.cart.attributes?.[k]||'')!==v))throw new Error('Readback differs');
          }
          this.render();this.querySelector('[data-status]').textContent=this.active()?this.text('saved'):this.text('expired');
        }catch(error){this.querySelector('[data-save]').hidden=false;this.querySelector('[data-status]').textContent=this.text('failed');throw error;}finally{this.busy=false;this.render();}
      };
      this.chain=this.chain.catch(()=>{}).then(task);return this.chain;
    }
    async checkout(form,submitter){
      if(this.checkingOut)return;this.checkingOut=true;this.render();
      try{
        let retries=0;while(this.cartBusy||document.querySelector('.cart__items--disabled')){if(++retries>50)throw new Error('Cart still updating');await new Promise(resolve=>setTimeout(resolve,200));}
        await this.save();
        if(this.count>this.entitlement&&this.active()){this.querySelector('[data-error]').scrollIntoView({block:'center',behavior:'smooth'});return;}
        this.passThrough=true;form.requestSubmit(submitter);this.passThrough=false;
      }catch{this.querySelector('[data-save]').hidden=false;this.querySelector('[data-status]').textContent=this.text('failed');}finally{this.checkingOut=false;this.render();}
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
